// extracted by mini-css-extract-plugin
export default {"welcomeSection":"welcome_welcomeSection__mRY7a","text":"welcome_text__D+4e3"};